export default __webpack_public_path__ + "static/media/dropdown-arrow.6d3c732b.svg";